import React from 'react';
import classNames from 'classnames';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import { AmplitudeFlagKeys } from 'types/amplitudeFlags';

import PowerUpIcon from '@/components/Images/ToolbarItemsIcons/PowerUpIcon';
import useIsExperimentActive from 'components/Amplitude/useIsExperimentActive';

const useStyles = makeStyles((theme) => ({
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  iconMargin: {
    marginLeft: 4,
    [theme.breakpoints.up('sm')]: {
      height: 16,
      width: 16,
    },
  },
  extraMarginIcon: {
    marginRight: 4,
  },
}));

const NavigationSplashLabel = (label) => {
  const { labelContainer, iconMargin, extraMarginIcon } = useStyles();
  const powerUpNavigationFlagActive = useIsExperimentActive(AmplitudeFlagKeys.midSizeProSplashNavigation);
  const powerUpLabel = () => (
    <Typography
      color="inherit"
      variant="inherit"
      className={classNames(labelContainer, { [extraMarginIcon]: label === 'Inbox' })}
    >
      {label}
      <PowerUpIcon className={iconMargin} />
    </Typography>
  );

  return powerUpNavigationFlagActive ? powerUpLabel() : label;
};

export default NavigationSplashLabel;
